import { useTranslation } from '@dagens/frontend-i18n';
import { dinero, toSnapshot } from 'dinero.js';
import Typography from '@carrot-deprecated/typography';
import Container from '@carrot-deprecated/container';
import { Money, zeroDinero } from 'utils/money';
import { fmtMoney } from 'utils/texts';

type DeliveryLineProps = {
  deliveryFee: Money;
  underThreshold: boolean;
};

const DeliveryLine = ({ deliveryFee, underThreshold }: DeliveryLineProps) => {
  const { t } = useTranslation();
  const constructedDeliveryFee = dinero(deliveryFee);

  return (
    <Container flex mt="xxs" justify="space-between">
      <Typography variant="paragraphSmall">
        {t('consumer:DagensDeliveryFee')}
      </Typography>
      <Typography variant="paragraphSmall">
        {underThreshold
          ? fmtMoney(constructedDeliveryFee)
          : fmtMoney(zeroDinero(toSnapshot(constructedDeliveryFee).currency))}
      </Typography>
    </Container>
  );
};

export default DeliveryLine;
